import moment from 'moment';

import { IAdminEvent } from '../../../../../store/admin/events/store';

export const getEventVerboseDate = (event: IAdminEvent): string => {
  if (!!event.end && !!event.start) {
    const startDate = `${moment(event.start)
      .format('MMMM D')
      .toString()}`;

    const endDate = `${moment(event.end)
      .format('MMMM D, YYYY')
      .toString()}`;

    return endDate.includes(startDate) ? endDate : `${startDate} - ${endDate}`;
  }

  return '';
};
